import { render } from "./project_youtube_video.vue?vue&type=template&id=14c739ac"
import script from "./project_youtube_video.vue?vue&type=script&lang=js"
export * from "./project_youtube_video.vue?vue&type=script&lang=js"

import "./project_youtube_video.vue?vue&type=style&index=0&id=14c739ac&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__